import React, { useEffect, useState } from 'react';
import { Circle, CircleMarker, FeatureGroup, MapContainer, Marker, Polygon, Popup, Rectangle, TileLayer, Tooltip, } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import L from "leaflet"
import styles from './map.module.css'
import { EditControl } from 'react-leaflet-draw';
import { GeoJSON } from 'react-leaflet';
import ngeohash from 'ngeohash';

const createDivIcon = (faClass, color, fontSize = 16) => {
    return L.divIcon({
        html: `
      <div style="display: flex; align-items: center; justify-content: center;">
        <i class="${faClass}" style="color: ${color}; font-size: ${fontSize}px;"></i>
      </div>
    `,
        className: '',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
    });
};
const getDynamicIcon = (medium, connected) => {
    const faClass = {
        'Ura Car': 'fa-solid fa-taxi',
        'Ura Premium': 'fa-solid fa-car-on',
        'Ura Bike': 'fa-solid fa-motorcycle',
    }[medium] || 'fa-solid fa-car';

    const color = connected === true
        ? 'green'
        : connected === false
            ? 'grey'
            : 'black';

    return createDivIcon(faClass, color);
};



const center = {
    lat: 25.6751,
    lng: 94.1086,
};

const Map = ({ locations, polypoints, createZone, radius, tripslocation, dumy, showName }) => {

    console.log(locations, "location in map compo")
    let coordinatescenter;

    if (polypoints && polypoints.length > 0) {

        const polygonp = L.polygon(polypoints);
        const bounds = polygonp.getBounds();
        coordinatescenter = bounds.getCenter();
    }

    const onDrawStart = (e) => {

        if (e.layerType === 'polygon') {
            // setDrawingPolygon(true);
            console.log('Polygon drawing started');
        }
    };
    const created = (e) => {
        const layer = e.layer;
        const coordinates = layer.getLatLngs()[0].map(latlng => [latlng.lat, latlng.lng]);
        console.log('Polygon created with coordinates:', coordinates);
        // Here you can handle the created polygon, e.g., save it to state or send it to a server
    }
    const edited = (e) => {
        const layers = e.layers;
        layers.eachLayer((layer) => {
            const coordinates = layer.getLatLngs()[0].map(latlng => [latlng.lat, latlng.lng]);
            console.log('Polygon edited with new coordinates:', coordinates);
            // Handle the edited polygon here
        });
    }
    const deleted = (e) => {
        const layers = e.layers;
        layers.eachLayer((layer) => {
            console.log('Polygon deleted:', layer);
            // Handle the deleted polygon here
        });
    }

    const [districtGeoJson, setDistrictGeoJson] = useState(null);

    // Helper function to determine color based on count
    const getColorByCount = (count) => {
        if (count >= 20) return '#dc2626'; // Red for high density
        if (count >= 10) return '#ea580c'; // Orange for medium-high
        if (count >= 5) return '#ca8a04';  // Yellow for medium
        if (count >= 3) return '#16a34a';  // Green for low-medium
        return '#2563eb'; // Blue for low
    };

    // Helper to show approximate area size based on geohash precision
    const getAreaSize = (precision) => {
        const sizes = {
            7: '153m x 153m',  // ~0.023 km²
            6: '1.2km x 0.6km', // ~0.73 km²
            5: '4.9km x 4.9km', // ~24 km²
            4: '39km x 19km',   // ~741 km²
        };
        return sizes[precision] || 'Varies by precision';
    };

    useEffect(() => {
        fetch('/india/india.geojson') // place in public/ or serve via express
            .then(res => res.json())
            .then(data => setDistrictGeoJson(data))
            .catch(err => console.error('Failed to load geojson', err));
    }, []);
    return (
        <div className={styles.container}>

            <MapContainer
                center={polypoints.length > 0 ? coordinatescenter : center}
                zoom={13}
                style={{ height: '100%', width: '100%' }}
            >
                <TileLayer
                    attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {locations?.length > 0 && locations.map((location, index) => (
                    <React.Fragment key={index}>
                        <Marker
                            position={location}
                            icon={getDynamicIcon(location.medium, location.connected)}
                        // index={index}
                        >
                            <Tooltip direction="top" offset={[0, -30]} opacity={1}>
                                <div>
                                    <strong>{location.driver_name}</strong><br />
                                    <strong>Cab id: </strong>{location.cab_id}
                                    <br />
                                    <strong>Contact: </strong>{location.driver_contact}
                                </div>
                            </Tooltip>
                        </Marker>
                        {radius && <Circle
                            center={location}
                            radius={500} // 1000 meters = 1 km
                            pathOptions={{
                                color: 'rgba(0, 123, 255, 0.5)',
                                fillColor: 'rgba(0, 123, 255, 0.2)',
                                fillOpacity: 0.4,
                            }}
                        />}
                    </React.Fragment>
                ))}
                {dumy && dumy.length > 0 && dumy.map((location, index) => (
                    <React.Fragment key={index}>
                        <Marker
                            position={[location.lat, location.lng]} // Make sure to use [lat, lng] format
                            icon={getDynamicIcon('Ura Car', false)}
                        >
                            {console.log(location.name, "location name")}
                            <Popup>{location.name}</Popup> {/* Display the name here */}
                        </Marker>

                        {/* <Marker
                            position={location}
                            icon={getDynamicIcon('Ura Car', false)}
                        /> */}
                        {radius && <Circle
                            center={location}
                            radius={1000} // 1000 meters = 1 km
                            pathOptions={{
                                color: 'rgba(0, 123, 255, 0.5)',
                                fillColor: 'rgba(0, 123, 255, 0.2)',
                                fillOpacity: 0.4,
                            }}
                        />}
                    </React.Fragment>
                ))}
                {/* {tripslocation && tripslocation.length > 0 && tripslocation.map((location, index) => (

                    <CircleMarker
                        key={index}
                        center={[location.lat, location.lon]}
                        pathOptions={{
                            color: 'black',
                            fillColor: location.status === 'completed' ? 'green' : 'red', // fill color depends on status
                            fillOpacity: 1,
                        }}
                        radius={5}
                    />
                ))} */}

                {tripslocation && tripslocation.length > 0 && tripslocation.map((location, index) => {
                    try {
                        const bbox = ngeohash.decode_bbox(location.geohash);

                        // Create polygon coordinates from bounding box
                        const polygonCoords = [
                            [bbox[0], bbox[1]], // SW
                            [bbox[0], bbox[3]], // NW
                            [bbox[2], bbox[3]], // NE
                            [bbox[2], bbox[1]], // SE
                            [bbox[0], bbox[1]]  // Cl
                        ];

                        return (

                            <Polygon
                                key={index}
                                positions={polygonCoords}
                                pathOptions={{
                                    color: 'black',
                                    fillColor: getColorByCount(location.count),
                                    fillOpacity: 0.6,
                                    weight: 2
                                }}
                            >
                                {/* <Popup>
                                    <div className="text-center">
                                        <strong>Geohash: {location.geohash}</strong><br />
                                        Total Trips: <strong>{location.count}</strong>
                                    </div>
                                </Popup> */}

                                <Tooltip permanent direction="center" style={tooltipStyle}>
                                    {location.count}
                                </Tooltip>
                            </Polygon>
                        );
                    } catch (error) {
                        console.error('Error processing geohash:', location.geohash, error);
                        return null;
                    }
                })}




                {!createZone && polypoints.length > 0 && <Polygon
                    positions={polypoints}
                    pathOptions={{
                        color: 'blue',
                        fillColor: 'blue',
                        fillOpacity: 0.3,
                    }}
                />}

                {createZone && <FeatureGroup>
                    <EditControl
                        position="topleft"
                        onCreated={created}
                        onEdited={edited}
                        onDeleted={deleted}
                        onDrawStart={onDrawStart}
                        draw={
                            {
                                rectangle: false,
                                circle: false,
                                polyline: false,
                                marker: false,
                                circlemarker: false
                            }
                        } />
                </FeatureGroup>}
                {districtGeoJson && (
                    <GeoJSON
                        data={districtGeoJson}
                        style={() => ({
                            color: '#555',
                            weight: 1,
                            fillColor: '#e0e0e0',
                            fillOpacity: 0.2,
                        })} s
                        onEachFeature={(feature, layer) => {
                            const name = feature.properties?.district || feature.properties?.name;
                            if (name) layer.bindPopup(name);
                        }}
                    />
                )}



            </MapContainer>
        </div >
    );
};
// Add this style object
const tooltipStyle = {
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    fontWeight: 'bold',
    fontSize: '14px',
    color: 'white',
    textShadow: '1px 1px 3px rgba(0,0,0,0.9)',
};
export default Map;
